module.exports = __webpack_public_path__ + "static/media/advocacia-xavier.479c8631.svg";